import { Routes } from '@angular/router';
import { SignInComponent } from './sign-in/sign-in.component';
import { RedirectEchoComponent } from './redirect-echo/redirect-echo.component';

export const routes: Routes = [
  {
    path: '',
    component: SignInComponent
  },
  {
    path: 'redirect-echo',
    component: RedirectEchoComponent
  },
  {
    path: '**',
    redirectTo: ''
  }
];
